import { defineComponent as _defineComponent } from 'vue'
import { computed, inject } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useEmitter } from '@rednex/gateway_core';
import { useStore } from 'vuex';
import { useVuelidate } from '@vuelidate/core';

import { getGlobalProps } from '@rednex/gateway_core';
//--- Function imports

//### Service imports
import ChangePasswordService from './change-password.service';
import { AlertService } from '@rednex/gateway_core';
//--- Service imports

//### Model imports
import { validationRules } from './change-password.validation';
import { validationState } from './change-password.validation';

import { GeneralInputType } from '@rednex/gateway_core';
//--- Model imports

//### Component imports
import { GeneralButton } from '@rednex/gateway_core';
import { GeneralInput } from '@rednex/gateway_core';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'change-password-modal',
  setup(__props, { expose: __expose }) {
  __expose();

//### Function imports
const alertService = inject<AlertService>('alertService');
const changePasswordService = inject<ChangePasswordService>('changePasswordService');
const emitter = useEmitter();
const globalProps = getGlobalProps();
const store = useStore();
const v$ = useVuelidate(validationRules, validationState);
//--- Setup

//### Store/Reactive Data
const currentUserId = computed(() => store.getters.currentUser.id);
//--- Store/Reactive Data

//### Variables const let
const doNotMatch = ref(null);
const error = ref(null);
const success = ref(null);
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
	validationState.newPassword = '';
	validationState.confirmPassword = '';
});
//--- Component Lifecycle

//### Functions
function changePassword(): void {
	if (validationState.newPassword !== validationState.confirmPassword) {
		error.value = null;
		success.value = null;
		doNotMatch.value = 'ERROR';
	} else {
		doNotMatch.value = null;
		changePasswordService
			.changePassword(currentUserId.value, validationState.newPassword)
			.then(() => {
				success.value = 'OK';
				error.value = null;
				alertService.showSuccess(globalProps, 'password.messages.success');
				emitter.emit('close-password-modal');
			})
			.catch(() => {
				success.value = null;
				error.value = 'ERROR';
			});
	}
}
//--- Functions

const __returned__ = { alertService, changePasswordService, emitter, globalProps, store, v$, currentUserId, doNotMatch, error, success, changePassword, get validationState() { return validationState }, get GeneralInputType() { return GeneralInputType }, get GeneralButton() { return GeneralButton }, get GeneralInput() { return GeneralInput } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})